import React from 'react';
import styles from './HeroSection.module.css';

/**
 * @component HeroSubtitle
 * @description Hero 섹션 부제목
 */
function HeroSubtitle({ children }) {
  return <p className={styles.heroSubtitle}>{children}</p>;
}

export default HeroSubtitle;
